// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";

import LoggedIn from "./loggedIn";
import LoggedOut from "./loggedOut";
import Sidebar from "./sidebar";

import { useLayout } from "./hooks";
import { ThemeContext } from "../../contexts/themeContext";

// ---------------------------------------------- the component
const Navbar: FunctionComponent = () => {
  // ---------------------------------------------- local state
  const { profile, areLoaded, isEmptied } = useLayout();

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <>
          <nav style={{ backgroundColor: theme.ui, marginBottom: "30px" }}>
            <div className="container nav-wrapper">
              <ul className="right">
                {!areLoaded ? null : isEmptied ? (
                  <LoggedOut />
                ) : (
                  <LoggedIn profile={profile} />
                )}
              </ul>
            </div>
          </nav>

          {!areLoaded ? null : isEmptied ? null : <Sidebar profile={profile} />}
        </>
      )}
    </ThemeContext.Consumer>
  );
};

export default Navbar;
